/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';

export function appMarketSearchBox({ search }) {
  pushClevertapEvent('Apps Search Box', {
    'Search Value Input': search,
  });
}

export function appMarketGetStarted({ uid, name }) {
  pushClevertapEvent('Apps Get Started', {
    'App Name': name,
    'App ID': uid,
  });
}

export function appMarketFindOutMore({ uid, name }) {
  pushClevertapEvent('Apps Find Out More', {
    'App Name': name,
    'App ID': uid,
  });
}

export function appMarketManageApp({ uid, name }) {
  pushClevertapEvent('Apps Manage App', {
    'App Name': name,
    'App ID': uid,
  });
}
